/**
 * Polls the garden run registry for pending_review count, refreshing every 60s.
 * The Sidebar surfaces this number on the "Garden" nav entry.
 */
import { create } from 'zustand';
import { gardenApi } from '@/services/api';
import { useClientStore } from './client';

interface GardenBadgeState {
  pendingReview: number;
  lastFetchedAt: number | null;
  fetch: () => Promise<void>;
  startPolling: () => () => void;
}

export const useGardenBadgeStore = create<GardenBadgeState>((set, get) => ({
  pendingReview: 0,
  lastFetchedAt: null,

  fetch: async () => {
    const clientUid = useClientStore.getState().selectedClientUid;
    if (!clientUid) return;
    try {
      const res = await gardenApi.listRuns(clientUid, {
        status: 'pending_review',
        limit: 100,
      });
      set({ pendingReview: res.count ?? res.runs.length, lastFetchedAt: Date.now() });
    } catch {
      // Silent — the badge is non-critical.
    }
  },

  startPolling: () => {
    void get().fetch();
    const id = setInterval(() => void get().fetch(), 60_000);
    return () => clearInterval(id);
  },
}));
